import { Editor } from "@monaco-editor/react";
import {
  Box,
  Chip,
  Dialog,
  DialogContent,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import MUICard from "../../../../../UI/Card/MUICard";
import Loading from "../../../../../UI/Loading/Loading";
import { usePageController } from "../../../../../../store/PageController";
import ComplilationModal from "../../../../ComplilationModal";
import { useNavigate } from "react-router-dom";

const FunctionModal = ({ open, onClose, funcData, refresh }) => {
  const [loading, setLoading] = useState(false);
  const [code, setCode] = useState(funcData?.code);
  const [funcName, setFuncName] = useState(funcData?.name);
  const [funcNameError, setFuncNameError] = useState("");

  const [file, setFile] = useState("");
  const [selectedFile, setSelectedFile] = useState("");

  const [compError, setCompError] = useState(false);
  const [compMessage, setCompMessage] = useState("");

  const navigate = useNavigate();

  const setCurrentComponent = usePageController(
    (state) => state.setCurrentComponent
  );

  const validateFuncName = (value) => {
    if (value.trim().length < 1) {
      return false;
    }
    if (value.length >= 50) {
      return false;
    }

    return true;
  };

  const handleFileChange = (event) => {
    const selectedFile_ = event.target.files[0];

    const reader = new FileReader();
    reader.onload = function (e) {
      setFile(e.target.result);
    };
    reader.readAsDataURL(selectedFile_);

    if (selectedFile_) {
      setSelectedFile(selectedFile_.name);
    } else {
      console.error("No File");
    }
  };

  const closeCompHandler = () => {
    setCompError(false);
    setLoading(false);
  };

  const saveBtnHandler = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (funcData.language !== "Web Server") {
      const isFuncNameValid = validateFuncName(funcName);
      setFuncNameError(!isFuncNameValid ? "Invalid Function Name" : "");

      if (!isFuncNameValid) {
        setLoading(false);
        return;
      }
    }
    try {
      let data;

      if (funcData?.language === "Web Server") {
        data = {
          id: funcData.id,
          name: selectedFile,
          file: file,
          code: "",
          language: "Web Server",
          uri: funcData.uri,
        };
      } else {
        data = {
          id: funcData.id,
          code: code,
          name: funcName,
          language: funcData.language,
          uri: funcData.uri,
        };
      }

      let url = "https://rawdat.ai/login/portal/function-edit-apply";
      const formData = JSON.stringify(data);
      const response = await fetch(url, {
        method: "PATCH",
        body: formData,
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!response?.ok && response.status === 401) {
        setLoading(false);
        navigate("/login");
        return;
      }

      if (!response?.ok && response.status === 500) {
        setLoading(false);
        const response_json = await response.text();

        setCompMessage(response_json);
        setCompError(true);
      }

      if (response.ok) {
        setLoading(false);
        refresh();
        onClose();
        setCurrentComponent("deployments");
      }
    } catch (error) {
      console.error("request did not go through");
      setLoading(false);
    }
  };

  if (!funcData) {
    return "Loading....";
  }

  return (
    <Dialog open={open} maxWidth={"md"} fullWidth onClose={onClose}>
      <DialogContent>
        <Box display={"flex"} flexDirection={"column"} gap={1.5}>
          {loading && (
            <Loading open={loading} closeLoading={() => setLoading(false)} />
          )}
          {compError && (
            <ComplilationModal
              open={compError}
              onClose={closeCompHandler}
              message={compMessage}
            />
          )}
          <Typography variant="title">Edit</Typography>

          {funcData?.language !== "Web Server" && (
            <MUICard>
              <Typography>Code</Typography>
              <Editor
                height="30vh"
                defaultLanguage={funcData.language.toLowerCase()}
                value={code}
                theme="vs-dark"
                onChange={(value) => {
                  setFuncNameError("");
                  setCode(value);
                }}
              />
            </MUICard>
          )}

          {funcData?.language !== "Web Server" && (
            <MUICard>
              <Typography>Function name</Typography>
              <TextField
                value={funcName}
                sx={{ width: "250px", backgroundColor: "#ffffff" }}
                placeholder="example"
                error={!!funcNameError}
                helperText={funcNameError}
                onChange={(e) => {
                  setFuncNameError("");
                  setFuncName(e.target.value);
                }}
              />
            </MUICard>
          )}

          <Box width={"100%"} display={"flex"} gap={1.5}>
            <MUICard>
              <Typography>Programming language</Typography>
              <Typography>{funcData.language}</Typography>
            </MUICard>

            <MUICard>
              <Typography>Uniform Resource Identifier (URI)</Typography>
              <Typography>{funcData.uri}</Typography>
            </MUICard>
          </Box>

          {funcData?.language !== "Web Server" && (
            <Box width={"100%"} display={"flex"} gap={1.5}>
              <MUICard>
                <Typography>Protocol</Typography>
                <Typography>{funcData.scheme}</Typography>
              </MUICard>

              <MUICard>
                <Typography>Hostname</Typography>
                <Typography>{funcData.hostname}</Typography>
              </MUICard>
            </Box>
          )}

          {funcData?.language === "Web Server" && (
            <Box width={"100%"} display={"flex"} gap={1.5}>
              <MUICard>
                <Typography>Upload File</Typography>

                <Box display={"flex"} gap={"1rem"}>
                  <Box>
                    <input
                      type="file"
                      style={{ display: "none" }}
                      id="file-input"
                      onChange={handleFileChange}
                    />
                    <label htmlFor="file-input">
                      <Chip
                        label={"Choose file"}
                        component="span"
                        clickable
                        color="primary"
                        variant="outlined"
                      />
                    </label>
                  </Box>

                  {!!selectedFile && <Typography>{selectedFile}</Typography>}
                </Box>
              </MUICard>
            </Box>
          )}

          <Box width={"100%"} display={"flex"} gap={1.5}>
            <Chip
              sx={{ width: "100px", cursor: "pointer" }}
              label={"Save"}
              variant="filled"
              onClick={saveBtnHandler}
              color="primary"
            />
            <Chip
              sx={{ width: "110px", cursor: "pointer" }}
              label={"Close"}
              variant="outlined"
              onClick={onClose}
              color="primary"
            />
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default FunctionModal;
